<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Postes de charge'"
          :description="'Modification d\'un poste de charge'"
        />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_poste_charge' }).catch(() => {})
          "
        >
          Liste des postes de charge
        </button>

        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_poste_charge-create' }).catch(() => {})
          "
        >
          <i class="fas fa-plus"></i>
          Nouvelle offre
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          style="min-width: 100px"
          @click.prevent="
            $router
              .push({
                name: 'gpao_poste_charge-show',
                params: { id: id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-eye font-size-17"></i> Aperçu
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row d-flex justify-content-lg-center">
                  <div class="col-md-4 col-lg-3">
                    <div class="form-group">
                      <label for="nom"
                        >Poste de charge
                        <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nom') }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Poste de charge"
                        maxlength="50"
                        required
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <div class="form-group">
                      <label for="entrepot"
                        >Entrepôt <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="entrepots"
                        :reduce="(entrepot) => entrepot.uuid"
                        v-model="form.entrepot"
                        placeholder="Entrepôt"
                      >
                        <template v-slot:option="{ nom, pays, description }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                          <span v-if="pays" class="d-block">
                            Pays : {{ pays }}
                          </span>
                          <span v-if="description" class="d-block">
                            Description : {{ description }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="entrepot"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('entrepot'),
                          }"
                        />
                        <has-error :form="form" field="entrepot"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-2">
                    <div class="form-group">
                      <label for="cout_horaire"
                        >Coût horaire <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('cout_horaire'),
                        }"
                        id="cout_horaire"
                        v-model="form.cout_horaire"
                        type="text"
                        placeholder="Coût horaire"
                        required
                      />
                      <has-error :form="form" field="cout_horaire"></has-error>
                    </div>
                  </div>
                  <div class="col-md-2 col-lg-1 mt-3 pt-1">
                    <switches
                      text-enabled="Statut actif"
                      text-disabled="Statut inactif"
                      v-model="form.statut"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedEmploye"
                      :items="employes"
                      item-text="nom"
                      placeholder="Recherche employé"
                      @select="onSelectedEmploye"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          employes.length
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div style="font-size: 1.1em">
                            <span class="d-block"> Nom : {{ item.nom }} </span>
                            <span class="d-block">
                              Prénom : {{ item.prenom ? item.prenom : '###' }}
                            </span>
                            <span class="d-block">
                              Matricule :
                              {{ item.matricule ? item.matricule : '###' }}
                            </span>
                            <span class="d-block">
                              Email : {{ item.email ? item.email : '###' }}
                            </span>
                            <span class="d-block">
                              Téléphone :
                              {{ item.telephone ? item.telephone : '###' }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="employeErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="employeErrorMessage"></span>
        </b-alert>

        <div class="row mt-n2">
          <div class="col-md-12">
            <b-card
              class="text-black"
              header-class="bg-silver border-bottom-0"
              no-body
            >
              <template #header>
                <div>
                  <h5 class="font-size-16 mb-0">
                    <i class="fa fa-users mr-0"></i> Composition de l'équipe du
                    poste de charge
                  </h5>
                </div>
              </template>
              <div class="row">
                <div class="col-md-12">
                  <table class="card table table-sm">
                    <thead>
                      <tr class="d-flex">
                        <th class="col-3">Nom</th>
                        <th class="col-2">Prénom</th>
                        <th class="col-2">Matricule</th>
                        <th class="col-2">Email</th>
                        <th class="col-2">Téléphone</th>
                        <th class="col-1 text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in item_lists"
                        :key="index"
                        class="d-flex"
                      >
                        <td class="col-3" style="vertical-align: middle">
                          {{ item.nom }}
                        </td>
                        <td class="col-2" style="vertical-align: middle">
                          {{ item.prenom ? item.prenom : '###' }}
                        </td>
                        <td class="col-2" style="vertical-align: middle">
                          {{ item.matricule ? item.matricule : '###' }}
                        </td>
                        <td class="col-2" style="vertical-align: middle">
                          {{ item.email ? item.email : '###' }}
                        </td>
                        <td class="col-2" style="vertical-align: middle">
                          {{ item.telephone ? item.telephone : '###' }}
                        </td>
                        <td
                          class="col-1 text-center"
                          style="vertical-align: middle"
                        >
                          <a
                            class="cursor-pointer"
                            @click.prevent="removeItem(index)"
                          >
                            <i class="fa fa-trash font-size-17 text-danger"></i
                          ></a>
                        </td>
                      </tr>
                      <tr v-if="item_lists.length === 0" class="d-flex">
                        <td class="text-center col-12">Aucune donnée</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/poste-charge';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';

export default {
  data() {
    return {
      form: new Form({
        nom: '',
        cout_horaire: '',
        entrepot: '',
        statut: false,
      }),
      employes: [],
      entrepots: [],
      item_lists: [],

      selectedEmploye: null,
      searchText: null,

      employeErrorMessage: null,
      title: 'Gestion des postes de charge - Edition',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    CoolSelect,
  },
  methods: {
    init() {
      this.entrepots = [];
      this.employes = [];
      this.item_lists = [];

      this.id = this.$route.params.id;

      window.axios
        .all([
          window.axios.get(URL.POSTE_CHARGE + '/' + this.id, {
            params: {
              edit: true,
            },
          }),
          window.axios.get(URL.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            Object.assign(this.form, resp1.data.poste_charge);
            this.entrepots = resp2.data.entrepots;
            this.employes = resp2.data.employes;
            this.item_lists = this.form.item_lists;
            delete this.form.item_lists;
          })
        )
        .catch();
    },
    onSelectedEmploye: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.item_lists,
          (o) => o.uuid === select.uuid
        );

        if (!objExiste) {
          let item = {
            uuid: select.uuid,
            nom: select.nom,
            prenom: select.prenom,
            matricule: select.matricule,
            email: select.email,
            telephone: select.telephone,
          };

          this.item_lists.push(item);
        }

        this.searchText = null;
        this.selectedEmploye = null;
      }
    },
    removeItem: function (index) {
      this.item_lists.splice(index, 1);
    },
    submit() {
      this.employeErrorMessage = null;
      this.form.employes = this.item_lists
        .filter((item) => item.uuid !== null)
        .map((item) => item.uuid);

      this.form
        .put(URL.POSTE_CHARGE + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('employes')) {
              this.employeErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
